module.exports = __webpack_public_path__ + "static/media/timeline-icon.d3a47a69.svg";